module.exports = __webpack_public_path__ + "img/step3-b.1bde773c.png";